import queryString from 'query-string'
import { toast } from 'react-toastify';
import { AUTH_SERVICE_URL } from './constant';

const CACHE_PREFIX = '__adportal'
let logorand = Math.round(Math.random() * 1000);

export const getPortalIds = () => {
    const params = queryString.parse(window.location.search);
    return {
        programId: params.pId && parseInt(params.pId),
        clientId: params.cId && parseInt(params.cId),
    }
}
export const portalLogoUrl = (programId, clientId) => {
    return `${AUTH_SERVICE_URL}/portal/logo/${clientId || ''}/${programId || ''}/Logo.jpg?r=${logorand}`;
}

export function base64EncodeUnicode(str) {
    if (typeof str != 'string') {
        str = JSON.stringify(str);
    }
    // First we escape the string using encodeURIComponent to get the UTF-8 encoding of the characters,
    // then we convert the percent encodings into raw bytes, and finally feed it to btoa() function.
    let utf8Bytes = encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function (match, p1) {
            return String.fromCharCode(parseInt("0x" + p1));
        }
    );

    return window.btoa(utf8Bytes);
}
export function base64DecodeUnicode(str) {
    return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''));
}

export const darkerGreyColor = {
    placeholder: defaultStyles => {
        return {
            ...defaultStyles,
            color: "#6E6E6E"
        };
    },
    control: (styles, { isDisabled }) => {
        return {
            ...styles,
            color: "#6E6E6E"
        }
    },
    option: (styles, { isDisabled }) => {
        return {
            ...styles,
            color: "#6E6E6E"
        };
    },
};

export class Storage {
    constructor() {
        this.storage = {};
    }
    setItem(key, data) {
        this.storage[key] = data;
    }

    getItem(key) {
        return this.storage[key];
    }

    removeItem(key) {
        delete this.storage[key];
    }
}
export class CacheService {
    constructor() {
        this.isSupported = this.isCheckSupported();
        this.inMemoryStorage = new Storage()
    }
    isCheckSupported() {
        try {
            const testKey = "__wqwqfwghjuitoy8675653243140707dgdnmkrye__";
            localStorage.setItem(testKey, testKey);
            localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }

    getStorage() {
        return this.isSupported ? localStorage : this.inMemoryStorage;
    }

    setCache(key, p) {
        this.getStorage().setItem(`${CACHE_PREFIX}_${key}`, base64EncodeUnicode(JSON.stringify(p)))
    }

    removeCache(key) {
        this.getStorage().removeItem(`${CACHE_PREFIX}_${key}`)
    }

    getCache(key) {
        let json = null
        try {
            json = JSON.parse(base64DecodeUnicode(this.getStorage().getItem(`${CACHE_PREFIX}_${key}`)))
        } catch (e) { }
        return json
    }
}

export const cacheService = new CacheService();

export class UserEventsChecker {
    // MAX_LEFT_TIME = 30 * 60 * 1000;//30 minutes

    eventTimer = null;
    eventCounter = 1;
    // eventLeftTimer = null;
    eventLeftPoint = 0;

    authInstance = null;

    lastTimeRefreshToken = null;
    constructor(authInstance) {
        this.authInstance = authInstance;
        this.registerEvents();
        return this;
    }

    registerEvents() {
        this.bindingEvents(window, ['focus', 'change', 'blur', 'select', 'contextmenu', 'drop', 'keydown',
            'copy', 'paste', 'scroll', 'resize', 'reset',
            'dblclick', 'click', 'mousedown', 'mouseup', 'mousemove', 'mouseover']);
    }

    bindingEvents(element, types) {
        types.forEach(t => {
            this.bindingEvent(element, t, (event) => {
                this.eventHandler(event);
            });
        });
    }

    bindingEvent(element, type, fn) {
        fn = fn || function () { };
        if (element.addEventListener) {
            element.addEventListener(type, fn, false);
            return true;
        } else if (element.attachEvent) {
            var r = element.attachEvent('on' + type, fn);
            return r;
        }
    }
    eventHandler(evt) {
        if (this.eventTimer) {
            clearTimeout(this.eventTimer);
        }
        // if (this.eventLeftTimer) {
        //     clearInterval(this.eventLeftTimer);
        //     this.eventLeftTimer = null;
        // }
        if (this.eventCounter > 100) {
            this.eventCounter = 0;
            this.refreshUserSession();
        }
        this.eventTimer = setTimeout(() => {
            this.eventCounter = 0;
            this.eventLeftPoint = new Date().getTime();
            // this.eventLeftTimer = setInterval(() => {
            this.refreshUserSession();
            let now = new Date().getTime();
            let dis = now - this.eventLeftPoint - (this.authInstance.expiryInterval * 60 * 1000);
            if (dis > 0) {
                //this.doLogout();
                //clearInterval(this.eventLeftTimer);
            } else {
                //console.log('User-Session checking steps');
            }
            // }, 60000);//1 minute
        }, 10000);//10 seconds
        this.eventCounter++;
    }

    doLogout() {
        if (this.authInstance && this.authInstance.doLogout) {
            this.authInstance.doLogout();
        }
    }

    async refreshToken() {
        if (this.authInstance && this.authInstance.refreshAuthJWT) {
            await this.authInstance.refreshAuthJWT();
        }
    }

    refreshUserSession() {
        //console.log('Checking access token expired or not?', this.authInstance )
        if (this.authInstance && this.authInstance.data && this.authInstance.isTokenExpired) {
            console.log('Token is expired!')
            toast.warn('Session Expired! \n Your current session is expired. Please login again')
            this.doLogout();
            // clearInterval(this.eventLeftTimer);
        } else if (this.authInstance && this.authInstance.data && this.authInstance.isTokenAboutToExpire) {
            let now = new Date().getTime();
            if (this.lastTimeRefreshToken && (now - this.lastTimeRefreshToken) < 1 * 60 * 1000) {
                return;
            }

            //refresh the token
            console.log("refreshing the token");
            this.refreshToken();
            this.lastTimeRefreshToken = new Date().getTime();
        } else {
            //let d = (this.authInstance && this.authInstance.expiry ? new Date(this.authInstance.expiry * 1000) : '-');
            //console.log('Token valid?', d)
        }
    }
}